import { generateGlobalVariables } from "@page-builder/utils";
import { RouteConfig } from "@page-builder/ts/types";

export function useModalVariables(
    routeConfig: RouteConfig | undefined | null,
): Record<string, unknown> {
    const templateConfig = routeConfig?.templateConfig;
    if (!templateConfig) {
        return {};
    }
    return generateGlobalVariables({
        headerAndFooter: templateConfig.headerAndFooter,
        theme: templateConfig.theme,
    }) as Record<string, unknown>;
}
